var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnionSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 42,
    viewBox: "0 0 149 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.683 41.4219C138.961 41.4219 148.104 32.2792 148.104 21.0011C148.104 9.723 138.961 0.580306 127.683 0.580305C122.913 0.580305 118.525 2.21563 115.049 4.95619C111.151 7.99476 109.202 9.51404 107.095 10.2273C104.365 11.1512 101.407 11.1512 98.6774 10.2273C96.5701 9.51404 94.621 7.99475 90.7229 4.95618C87.247 2.21562 82.8592 0.580301 78.0894 0.580301L21.2029 0.580296C9.92482 0.580295 0.782138 9.72299 0.782137 21.0011C0.782136 32.2792 9.92482 41.4219 21.2029 41.4219L78.0894 41.4219C82.8592 41.4219 87.247 39.7865 90.7229 37.046C94.621 34.0074 96.5701 32.4881 98.6774 31.7749C101.407 30.851 104.365 30.851 107.095 31.7749C109.202 32.4881 111.151 34.0074 115.049 37.046C118.525 39.7866 122.913 41.4219 127.683 41.4219Z",
    fill: "#CECECE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnionSvg);
export default __webpack_public_path__ + "static/media/union-svg.8d7398256820dd9b8993c110e7509a83.svg";
export { ForwardRef as ReactComponent };